import React from 'react';
import { connect } from 'react-redux';
import "../styles/patientLookup.css";
import * as actions from "../actions/index";
import SearchByFieldStep from "../components/SearchByFieldStep.jsx";

const mapStateToProps = state => {
    return {
        mrnField: state.questionnaire.mrnField,
        searchValue: state.patients.searchValue
    }
};

const mapDispatchToProps = (dispatch) => {
    return {
        changePatientSearchValue: (newValue) => dispatch(actions.changePatientSearchValue(newValue)),
        searchPatient: () => dispatch(actions.searchPatient())
    }
};

const SearchByFieldStepController = connect(
    mapStateToProps,
    mapDispatchToProps
)(SearchByFieldStep);

export default SearchByFieldStepController;